import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Avatar,
  Chip,
  Button,
  Divider,
  Grid2,
  Stack,
  IconButton,
  Tooltip,
} from "@mui/material";
import { VideoCall, AccessTime, Link, ContentCopy, CheckCircle } from "@mui/icons-material";

const MeetingCard = ({ meeting }) => {
  const [copied, setCopied] = useState({ field: "", value: "" });

  const startTime = new Date(meeting.start.dateTime).toLocaleString("en-IN", {
    dateStyle: "medium",
    timeStyle: "short",
  });
  const endTime = new Date(meeting.end.dateTime).toLocaleString("en-IN", {
    timeStyle: "short",
  });

   const handleCopy = (text, field) => {
    navigator.clipboard.writeText(text);
    setCopied({ field, value: text });

    // Reset message after 2s
    setTimeout(() => setCopied({ field: "", value: "" }), 2000);
  };

  return (
    <Card sx={{
      borderRadius: 3,
      boxShadow: 4,
      height: "100%",
      width: "100%",
      maxWidth: 420, // <-- fix max width
      minWidth: {xs: 340, sm: 400}, // <-- optional: keeps it balanced
      display: "flex",
      flexDirection: "column",
    }}>
      <CardContent>
        {/* Title */}
        <Typography variant="h5" fontWeight="bold" gutterBottom sx={{textTransform: 'capitalize'}}>
          {meeting.title}
        </Typography>

        {/* Time */}
        <Stack direction="row" alignItems="center" spacing={1} mb={2}>
          <AccessTime fontSize="small" color="action" />
          <Typography variant="body2" color="text.secondary">
            {startTime} – {endTime}
          </Typography>
        </Stack>

        {/* Description */}
        {/* <Typography variant="body2" sx={{ mb: 2 }}>
          {meeting.description}
        </Typography> */}

        <Divider sx={{ my: 1 }} />

        {/* Attendees */}
        <Typography variant="subtitle2" fontWeight="medium" gutterBottom>
          Attendees
        </Typography>
        {/* <Stack direction={{ md: "row", xs: "column" }} spacing={1} flexWrap="wrap" mb={2}> */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1, 
          }}
        >
          {meeting.attendees.map((att, idx) => (
            <Chip
              key={idx}
              // avatar={<Avatar>{att.email.charAt(0).toUpperCase()}</Avatar>}
              // avatar={<Avatar>{att.firstName.charAt(0).toUpperCase()}</Avatar>}
              // label={`${att.firstName} ${att.lastName}`}
              label={`${att.email}`}
              color={att.responseStatus === "accepted" ? "success" : "default"}
              variant="outlined"
              // sx={{ mb: 1 }}
            />
          ))}
        </Box>

        <Divider sx={{ my: 1 }} />

        {/* Meeting Link */}
        <Stack spacing={1} mb={2}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<VideoCall />}
            href={meeting.conferenceData?.video?.uri || "#"}
            target="_blank"
            sx={{ borderRadius: 3 }}
          >
            Join Meeting
          </Button>
          {/* <Typography variant="caption" color="text.secondary">
            Meeting ID: {meeting.conferenceData.video.meetingCode} | Passcode:{" "}
            {meeting.conferenceData.video.passcode}
          </Typography> */}
          {/* Meeting ID + Copy */}
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="caption" color="text.secondary">
              Meeting ID: {meeting.conferenceData?.video?.meetingCode}
            </Typography>
            <Tooltip title="Copy Meeting ID">
              <IconButton
                size="small"
                onClick={() =>
                  handleCopy(meeting.conferenceData?.video?.meetingCode || "", "id")
                }
              >
                <ContentCopy fontSize="inherit" />
              </IconButton>
            </Tooltip>
            {copied.field === "id" && (
              <Typography
                variant="caption"
                color="success.main"
                sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
              >
                <CheckCircle fontSize="inherit" /> Copied
              </Typography>
            )}
          </Stack>

          {/* Passcode + Copy */}
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="caption" color="text.secondary">
              Passcode: {meeting.conferenceData?.video?.passcode || ""}
            </Typography>
            <Tooltip title="Copy Passcode">
              <IconButton
                size="small"
                onClick={() =>
                  handleCopy(meeting.conferenceData?.video?.passcode || "", "passcode")
                }
              >
                <ContentCopy fontSize="inherit" />
              </IconButton>
            </Tooltip>
            {copied.field === "passcode" && (
              <Typography
                variant="caption"
                color="success.main"
                sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
              >
                <CheckCircle fontSize="inherit" /> Copied
              </Typography>
            )}
          </Stack>
        </Stack>

        <Divider sx={{ my: 1 }} />

        {/* Google Calendar Link */}
        <Button
          variant="outlined"
          startIcon={<Link />}
          href={meeting.htmlLink}
          target="_blank"
          sx={{ borderRadius: 3 }}
        >
          View in Google Calendar
        </Button>
      </CardContent>
    </Card>
  );
};

export default MeetingCard;
